import { getRelativeAssetSize } from 'helpers/getRelativeAssetSize'
import { ImageAsset } from 'models/Asset'
import { isText } from 'Util/assets'
import { getImageAspectRatio } from '~/Util/sourceFile'

export function createAssetFromSourceFile(file, { startTime,
  layerId,
  pregeneratedId,
  creationOrder,
  videoSize,
  aspectRatio }) {
  let fileData = {
    layerId,
    startTime,
    creationOrder,
  }

  if (file instanceof ImageAsset) {
    const { size, originalSize } = file.settings
    const { height, width } = size
    fileData.settings = { ...file.settings,
      relativeSize: getRelativeAssetSize({ width, height }, videoSize),
      aspectRatio: aspectRatio || getImageAspectRatio({ width, height }) }
    if (!originalSize) {
      fileData.settings.originalSize = fileData.settings.size
    }
  }
  if (isText(file.type)) {
    fileData = {
      ...fileData,
      width: 100,
      height: 100,
    }
  }
  return file.clone(fileData, { pregeneratedId })
}

export const createGroupAssetsFromSourceFiles = (files, {
  startTime,
  startTimeByAssetId,
  layerId,
  pregeneratedIds, // for single file
  creationOrderByLayerId,
  videoSize,
  aspectRatio,
  isSouceFile,
}) => {
  let startAssetTime = startTime
  return files.map((file, index) => {
    const newAsset = createAssetFromSourceFile(file, {
      startTime: isSouceFile ? startAssetTime : startTimeByAssetId[file.id],
      // file?.layerId - if redo assets
      layerId: isSouceFile ? layerId : file?.layerId,
      pregeneratedId: pregeneratedIds[index],
      creationOrder: isSouceFile
        ? creationOrderByLayerId[layerId]
        : creationOrderByLayerId[file.layerId],
      videoSize,
      aspectRatio,
    })
    startAssetTime += file.duration
    return newAsset
  })
}
